import React, { SyntheticEvent } from 'react';
import cx from 'classnames';

import { getTailwindColor, scaleImage } from '@trqk/utils';

const iconId = 'file-trqk-mark';

const originalDimensions = {
    width: 24,
    height: 24,
};

// Made by overlaying the waveform from "App Source Files/Assets/SVGs/mark_trqk.svg" onto the folder
// outline from "stockholm-icon-set/Files/Folder.svg"

export const IconFileTrqkMark = (props: IconProps): JSX.Element => {
    const fillColor = props?.fillColor ?? 'tertiary-400';
    const fill = getTailwindColor(fillColor);
    const { height, width } = scaleImage(originalDimensions, props);
    const { addClasses, handleClick } = props;
    const classNames = cx(addClasses, 'inline', {
        'cursor-pointer': handleClick,
    });

    return (
        <svg
            aria-labelledby={iconId}
            className={classNames}
            height={height}
            onClick={(e: SyntheticEvent): void => {
                if (handleClick) {
                    handleClick(e);
                }
            }}
            viewBox={`0 0 ${originalDimensions.width} ${originalDimensions.height}`}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title id={iconId}>File Icon With Audio Waveform</title>
            <g fillRule="evenodd" fill="none">
                <path d="M0 0h24v24H0z" />
                <path
                    opacity=".5"
                    fillRule="nonzero"
                    fill={fill}
                    d="M5.857 2h7.88a1.5 1.5 0 01.968.355l4.764 4.029A1.5 1.5 0 0120 7.529v12.554c0 1.79-.02 1.917-1.857 1.917H5.857C4.02 22 4 21.874 4 20.083V3.917C4 2.127 4.02 2 5.857 2z"
                />
            </g>
            <path
                fillRule="nonzero"
                fill={fill}
                d="M6.757 9.42c-.39 0-.706.346-.719.775v5.75c0 .429.316.774.707.774.39 0 .706-.345.706-.774v-5.75c.013-.415-.303-.774-.694-.774zM8.826 10.292c-.39 0-.706.345-.719.774v4.008c0 .429.316.774.707.774.39 0 .706-.345.706-.774v-4.008c.013-.429-.303-.774-.694-.774zM10.895 8.55c-.39 0-.706.346-.706.774v7.492c0 .429.315.774.706.774.391 0 .707-.345.707-.774V9.324c.012-.415-.316-.774-.707-.774zM12.977 6.573c-.391 0-.706.346-.706.774l-.013 5.695v.056l.013 5.695c0 .428.315.774.706.774.391 0 .706-.346.706-.788l-.012-5.709.012-5.723c0-.428-.315-.774-.706-.774zM15.046 10.388c-.391 0-.706.346-.72.774v3.843c0 .429.316.774.707.774.391 0 .707-.345.707-.774l.013-1.935v-1.908c0-.428-.316-.774-.707-.774zM17.809 9.283c0-.429-.315-.775-.707-.775-.39 0-.706.346-.706.775V16.858c0 .428.315.774.706.774.392 0 .707-.346.707-.774V13.07z"
            />
        </svg>
    );
};
